module.exports = __webpack_public_path__ + "img/content-with-img-links-hyundai.91410a7f.jpg";